import { render } from "./AssessmentDescriptors.vue?vue&type=template&id=8295f5ea&scoped=true"
import script from "./AssessmentDescriptors.vue?vue&type=script&lang=js"
export * from "./AssessmentDescriptors.vue?vue&type=script&lang=js"

import "./AssessmentDescriptors.vue?vue&type=style&index=0&id=8295f5ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8295f5ea"

export default script